export * from '@cipafacil/services/config/config.module';
export * from '@cipafacil/services/config/config.service';
